module.exports = __webpack_public_path__ + "fonts/noto-sans-jp-v25-latin-700.b631d23.eot";